import Api from '../../app/services/api';

/* VOIVODESHIP */
export const getVoivodeships = (params) => Api.get('/dictionary/voivodeship', params);

/* FUEL TYPES */
export const getFuelTypes = (params) => Api.get('/dictionary/fuel', params);

/* CAR */
export const getCar = (id) => Api.get(`/dictionary/car/${id}`);

export const getCars = (params) => Api.get('/dictionary/car', params);

/* MODEL */
export const getModel = (id) => Api.get(`/dictionary/model/${id}`);

export const getModels = (params) => Api.get('/dictionary/model', params);

export const saveCarModel = (params) => Api.post('/dictionary/model', params);

export const deleteModel = (id) => Api.delete(`/dictionary/model/${id}`);

/* WARRANTIES */
export const getWarranties = (params) => Api.get('/dictionary/warranty', params);

export const getWarrantyDict = (id) => Api.get(`/dictionary/warranty/${id}`);

export const saveWarrantyDict = (params) => Api.post('/dictionary/warranty', params);

/* WARRANTY OPTION */
export const getWarrantyOptions = (params) => Api.get('/dictionary/warranty-options', params);

export const getWarrantyOptionDict = (id) => Api.get(`/dictionary/warranty-option/${id}`);

export const saveWarrantyOptionDict = (params) => Api.post('/dictionary/warranty-option', params);

/* MODEL */
export const getWarrantiesForCar = (params) => Api.get('/dictionary/warranty-car', params);

export const getWarrantyOptionsForCar = (params) => Api.get('/dictionary/warranty-options-car', params);

/* COMPANY GROUPS */
export const getCompanyGroup = (id) => Api.get(`/dictionary/company-groups/${id}`);

export const getCompanyGroups = (params) => Api.get('/dictionary/company-groups', params);

export const saveCompanyGroup = (params) => Api.post('/dictionary/company-group', params);

export const saveCompanyGroupWarranty = (params) => Api.post('/dictionary/company-group-warranties', params);

export const deleteCompanyGroupWarranty = (id) => Api.delete(`/dictionary/company-group-warranty/${id}`);
// export const getCompanyGroup = (id) => null;

// export const getCompanyGroups = (params) => null;

// export const saveCompanyGroup = (params) => null;


/* LOGS */
export const getLogs = (params) => Api.get('/dictionary/logs', params);

/* MANUFACTURER */
export const deleteManufacturer = (id) => Api.delete(`/dictionary/manufacturer/${id}`);

export const saveCarDict = (params) => Api.post('/dictionary/manufacturer', params);

/* WARRANTY */
export const deleteWarranty = (id) => Api.delete(`/dictionary/warranty/${id}`);

export const deleteWarrantyOption = (id) => Api.delete(`/dictionary/warranty-option/${id}`);


/* BREAKDOWN TYPES */

export const deleteBreakdownType = (id) => Api.delete(`/dictionary/breakdown-type/${id}`);

export const saveBreakdownType = (params) => Api.post('/dictionary/breakdown-type', params);

export const getBreakdownTypes = (params) => Api.get('/dictionary/breakdown-types', params);

export const getBreakdownType = (id) => Api.get(`/dictionary/breakdown-types/${id}`);
